import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import NodeZeroMappingForm from './NodeZeroMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function NodeZeroCredentialsForm(props, ref) {
    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    }, {
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={NodeZeroMappingForm}
        />
    )
}

export default forwardRef(NodeZeroCredentialsForm);